import { useLocation } from 'react-router-dom';
import { LP_PAGE_MAP } from '../../data/landingPages';
import { LandingPageTemplate } from './LandingPageTemplate';

export function LpPage() {
  const { pathname } = useLocation();
  const slug = pathname.replace(/^\//, '');
  const page = LP_PAGE_MAP[slug];
  if (!page) return null;
  return <LandingPageTemplate {...page} />;
}
